'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = require('react-redux');

var _redux = require('redux');

var _LayerCreator = require('../components/LayerCreator');

var _LayerCreator2 = _interopRequireDefault(_LayerCreator);

var _constants = require('../../../constants');

var _selectors = require('../../../store/blueprint/selectors');

var _actions = require('../../../store/blueprint/actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
  return {
    layerSchema: (0, _selectors.buildLayerSchemaCascaderOptions)(state),
    blueprint: state[_constants.STORE_NAMESPACE].blueprints.blueprint,
    loading: state[_constants.STORE_NAMESPACE].blueprints.loading,
    putBlueprintLoading: state[_constants.STORE_NAMESPACE].blueprints.putBlueprintLoading,
    savingCSV: state[_constants.STORE_NAMESPACE].blueprints.savingCSV,
    WSSEToken: state.session.wsse,
    mediaActionUrl: (0, _selectors.buildMediaActionURLWithID)(state),
    mediaActionURLForThumbnails: (0, _selectors.buildMediaActionURLForThumbnails)(state),
    mediaActionURLForGuides: (0, _selectors.buildMediaActionURLForGuides)(state),
    mediaActionURLForAeFiles: (0, _selectors.buildMediaActionURLForAeFiles)(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onCreate: (0, _redux.bindActionCreators)(_actions.postLayerTemplates, dispatch),
    onSaveCSV: (0, _redux.bindActionCreators)(_actions.postGenerateCSV, dispatch),
    onBlueprintModalSubmit: (0, _redux.bindActionCreators)(_actions.putBlueprint, dispatch)
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_LayerCreator2.default);


//////////////////
// WEBPACK FOOTER
// ./~/@adparlor-devops/ms-paint/lib/modules/LayerCreator/containers/LayerCreatorContainer.js
// module id = 3933
// module chunks = 8